module.exports = __webpack_public_path__ + "static/media/openExternal.f4fefb89.svg";